<div class="modal fade" id="modalPayment" tabindex="-1" aria-labelledby="modalPaymentLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="{{messageType}}">{{message}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>

<div class="housing-page">
  <div class="housing-header">
    <div>
      <span class="tag">Paiement immobilier</span>
      <h1>Payez vos souscriptions</h1>
   </div>
  </div>

  <div class="housing-card">
    <!-- Step 1: Search Customer -->
    @if (isSearching) {
    <div class="form-section">
      <form [formGroup]="searchForm" (ngSubmit)="searchCustomer()" class="search-form">
        <div class="field-group">
          <label for="phone">Entrer votre numéro de téléphone</label>
          <input id="phone" type="text" formControlName="phone" placeholder="Ex: 22177007980" />
          <div class="error">
            @if (submitted && f['phone'].invalid) {
            <span>Le numéro de téléphone est requis.</span>
            }
          </div>
        </div>
        <div class="form-actions">
          <button type="submit" class="btn btn-primary" [disabled]="searchForm.invalid">Rechercher</button>
        </div>
      </form>
    </div>
    }

    <!-- Step 2: Select Promoter -->
    @if (isSelectingPromoter) {
    <div class="form-section">
      @if (message) {
      <div class="alert alert-info">{{message}}</div>
      }
      <div class="promoters-grid">
        <select class="form-select" (change)="selectPromoter($event)">
            <option value="0">Sélectionner un promoteur</option>
        @for (promoter of promoters; track promoter.id) {
        <option class="promoter-card" value="{{promoter.id}}" >{{promoter.name}}</option>
        }
        </select>
      </div>
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="goBack()">Retour</button>
      </div>
    </div>
    }

    <!-- Step 3: Select Subscription -->
    @if (isSelectingSubscription) {
    <div class="form-section">
      <h3>Souscriptions de {{ selectedPromoter?.name }}</h3>
      <div class="subscriptions-grid">
        @for (subscription of promoterSubscriptions; track subscription.id) {
        <div class="subscription-card" (click)="selectSubscription(subscription)">
          <div class="subscription-header">
            <h4>{{ subscription.product?.name }}</h4>
          </div>
          <div class="subscription-details">
            <p><strong>Montant périodique: </strong>
              <span class="highlight-amount">{{ subscription.periodicAmount }} CFA</span>
            </p>
            <p><strong>Fréquence:</strong> {{ getFrequencyLabel(subscription.paymentFrequency) }}</p>
            <p><strong>Durée:</strong> {{ subscription.product!.durationYears!! }} an(s)</p>
            <p><strong>Date de début:</strong> {{ subscription.startDate | date }}</p>
          </div>
        </div>
        }
      </div>
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="goBack()">Retour</button>
        <button type="button" class="btn btn-secondary" (click)="resetSearch()">Nouvelle recherche</button>
      </div>
    </div>
    }

    <!-- Step 4: Payment -->
    @if (isPayment && selectedSubscription) {
    <div class="form-section">
      <h3>Paiement de la souscription</h3>

      <div class="payment-summary">
        <div class="summary-card">
          <h4>Détails de la souscription</h4>
          <div class="summary-details">
            <p><strong>Nom:</strong> {{ customerData?.customer?.firstName }} {{ customerData?.customer?.lastName }}</p>
            <p><strong>Produit:</strong> {{ selectedSubscription.product?.name }}</p>
            <p><strong>Montant périodique:</strong>
              <span class="highlight-amount">{{ selectedSubscription.periodicAmount }} CFA</span>
            </p>
            <p><strong>Fréquence:</strong> {{ getFrequencyLabel(selectedSubscription.paymentFrequency) }}</p>
            <p><strong>Prix total : </strong> {{selectedSubscription.product?.price}}</p>
          </div>
        </div>
      </div>

      <form [formGroup]="paymentForm" class="payment-form">
        <div class="grid-row">
          
          <div class="field-group">
            <label>Entrer le montant à payer</label>
            <div class="amount-display">
              <input type="number" formControlName="amount" name="amount" >
            </div>
          </div>
        </div>

        <div class="payment-methods-section">
          <h4>Choisir le moyen de paiement</h4>
          <div class="payment-methods-grid">
            @for (method of paymentMethods; track method.code) {
            <div class="payment-method-card" [class.active]="paymentNetwork === method.code"
                 (click)="onSelectPaymentMethod(method.code)" [attr.data-method]="method.code">
              <img [src]="method.icon" [alt]="method.label" class="payment-icon" />
              <p>{{ method.label }}</p>
            </div>
            }
          </div>
        </div>

        @if (isWallet) {
        <div class="field-group full-width">
          <label for="paymentPhone">Numéro de téléphone de paiement</label>
          <input id="paymentPhone" type="text" formControlName="phone" placeholder="Ex: 22177007980" />
          <div class="error">
            @if (p['phone'].invalid && p['phone'].touched) {
            <span>Le numéro de téléphone est requis pour ce mode de paiement.</span>
            }
          </div>
        </div>
        }

        @if(!clickedPayForm){
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="goBack()">Retour</button>
          <button type="button" class="btn btn-primary" (click)="processPayment()"
                  [disabled]="!isValid() || paymentNetwork === ''">Payer</button>
        </div>
        }
      </form>
    </div>
    }@else {
         @if(qrCode.length) {
        <div  class="row justify-content-center">
          <div class="d-flex justify-content-center" style="width: 300;">Scannez et payez </div>
          <div class="d-flex justify-content-center">
            @if(paymentNetwork.toLocaleLowerCase() == 'wvsn'){
             <div class="d-block">
              <img class="img-fluid" src="images/wave-logo.webp" alt="wave" width="120" height="50">
            </div>
            }
             @if(paymentNetwork.toLocaleLowerCase() == 'omsn'){
             <div class="d-block">
              <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
            </div>
            }
            
          </div>
          <div class="d-flex justify-content-center">
            <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
          </div>
          @if(!isDesktop){
          <div class="d-grid gap-2 col-6 mx-auto">
                <button class="btn btn-primary" (click)="openUrl(qrCode)">Ouvrir avec l'application</button>
              </div>
            }
        </div>
    }
    }
  </div>
</div>
